import { ChatService } from './../../../../services/chat.service';
import { AppSetting } from './../../../../global/appsetting';
import { Socket } from 'ngx-socket-io';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmailServiceService, Mail } from '../../../../services/email-service.service';
import { LoaderService } from '../../../../services/loader.service';
import { ChatMsg } from 'src/app/services/chat.service';
import { GaAnalyticsService, EVENT_TYPES } from 'src/app/services/ga-analytics.service';


@Component({
  selector: 'app-chat-bot-inner',
  templateUrl: './chat-bot-inner.component.html',
  styleUrls: ['./chat-bot-inner.component.scss']
})
export class ChatBotInnerComponent implements OnInit {

  timeOfOperation = [9, 15];
  currentMsg = '';
  alertTxt = ` שלום, אנא הזן שם כדי להתחיל בצ'ט`;
  isThereError = false;
  generalErrorMsg = `אופס! התרחשה תקלה בחיבור.
  אנא נסו שוב מאוחר יותר או פנו אלינו באחד מהדרכים האחרות המוצעות באתר (אימייל, וואצפ או פייסבוק)`;

  timeErrorMsg = `
  היי איזה כיף שבחרת תכנון אונליין :-)<br />
אנחנו זמינים בצ'ט משעה ${this.timeOfOperation[0]}:00-${this.timeOfOperation[1]}:00<br />
שלח/י הודעה בוואטסאפ ונענה לך בהקדם:<br />
<a href='https://api.whatsapp.com/send?phone=${this.appsetting.phone}&text=היי,%20יש%20לי%20שאלה' target='blank'><div class="watsapp-chat-icon chat-share-icon"></div><br /><a>
אפשר גם במייל ובמסנגר:<br />
<a href='http://m.me/gilarchonline' target='blank'><div class="messanger-chat-icon chat-share-icon"></div></a>
<div id="mail-chat-icon"  class="mail-chat-icon chat-share-icon"></div>
`;
  constructor(private socket: Socket,
    private mailService: EmailServiceService,
    private route: ActivatedRoute,
    public loaderService: LoaderService,
    public appsetting: AppSetting, public chatService: ChatService, private gaAnalyticsService: GaAnalyticsService) {
    this.socket = new Socket({ url: 'https://frozen-reef-94597.herokuapp.com/', options: {} });

    window.onresize = function () {
      const chatBotFrame = document.querySelector('.chat-bot-frame');
      chatBotFrame.scrollTop = chatBotFrame.scrollHeight;
    };
    this.socket.on('messageFromSr', (msg) => {
      this.chatService.msgList.push(msg);
      const chatBotFrame = document.querySelector('.chat-bot-frame');
      setTimeout(() => {
        chatBotFrame.scrollTop = chatBotFrame.scrollHeight;
      }, 0);
    });
    if (this.chatService.roomId == '') {
      this.socket.on('setRoomId', (msg) => {
        this.chatService.roomId = msg;

        this.sendChatMailToAdmin();

      });
    }

    this.socket.on('setLatestMsgs', (msgs: Array<ChatMsg>) => {
      this.chatService.msgList = msgs;
    });
    this.socket.on('adminEnteredTheRoom', () => {
      this.chatService.adminIsOnLive = true;
      this.chatService.inConversition = true;
    });
    socket.on('disconnect', () => {
      console.log(`${this.chatService.userName} disconnected`);
    });
  }

  ngOnInit() {
    if (this.route.snapshot.params.id && window.location.href.indexOf('chat-admin') > -1) {
      this.chatService.userName = 'admin';
      this.chatService.userType = 'admin';
      this.chatService.adminIsOnLive = true;
      this.chatService.roomId = this.route.snapshot.params.id;
      this.socket.emit('getRoomNumber', { userName: this.chatService.userName, userType: this.chatService.userType, roomId: this.chatService.roomId });
    }
    document.getElementById('chat-bot-input').focus();
    const now = new Date();
    if (now.getHours() < this.timeOfOperation[0] || now.getHours() > this.timeOfOperation[1]) {
      this.alertTxt = this.timeErrorMsg;
      this.addClickLisnerOnEmailIcon();
    }
  }
  generateNewStartMsg() {
    this.chatService.msgList.push({
      text: `שלום <b>${this.chatService.userName}</b>`,
      date: new Date(),
      userName: 'Bot',
      roomId: this.chatService.roomId,
      userType: this.chatService.userType
    });
    this.sendMsg();
    setTimeout(() => {
      const now = new Date();
      if (now.getHours() > this.timeOfOperation[0] && now.getHours() < this.timeOfOperation[1]) {
        this.chatService.msgList.push({
          text: `היי איזה כיף שבחרת תכנון אונליין:-)<br />
          כבר מתפנה אליך נציג<br />
          נסמן לך כשאנחנו פה<br />
          (כאשר נציג מתחבר יהיה צפצוף + היבהוב קבוע של הודעה שנציג מחובר)`,
          date: new Date(),
          userName: 'Bot',
          roomId: this.chatService.roomId,
          userType: this.chatService.userType
        });
      } else {
        this.chatService.msgList.push({
          text: this.timeErrorMsg,
          date: new Date(),
          userName: 'Bot',
          roomId: this.chatService.roomId,
          userType: this.chatService.userType
        });
        this.addClickLisnerOnEmailIcon();
      }
      this.sendMsg();
    }, 2000);

  }
  addClickLisnerOnEmailIcon() {
    setTimeout(() => {
      document.getElementsByClassName('mail-chat-icon')[0].addEventListener('click', (e) => {
        (<any>document.getElementsByClassName('email-link')[0]).click();
      });
    }, 500);
  }
  sendNewMsg() {
    if (!this.chatService.userName) {
      this.chatService.userName = this.currentMsg;
      this.currentMsg = '';
      this.loaderService.displayLoader(false);
      this.socket.emit('getRoomNumber', { userName: this.chatService.userName, roomId: this.chatService.roomId });
      setTimeout(() => {
        if (this.chatService.roomId === '') {
          this.loaderService.hideLoader();
          this.isThereError = true;
          this.alertTxt = this.generalErrorMsg;
        }
      }, 20000);
    } else if (this.currentMsg && this.currentMsg !== '') {
      this.chatService.msgList.push({ text: this.currentMsg, date: new Date(), userName: this.chatService.userName, roomId: this.chatService.roomId, userType: this.chatService.userType });
      this.sendMsg();
    }
  }
  sendMsg() {
    this.socket.emit('message', this.chatService.msgList[this.chatService.msgList.length - 1]);
    this.currentMsg = '';
    const chatBotFrame = document.querySelector('.chat-bot-frame');
    setTimeout(() => {
      chatBotFrame.scrollTop = chatBotFrame.scrollHeight;
    }, 0);
  }
  sendChatMailToAdmin() {
    const mail = new Mail();
    const link = window.location.origin + '/chat-admin/conn/' + this.chatService.roomId;
    mail.mailType = 4;
    mail.body = `<div style="direction: rtl"><div>לחץ על הקישור הבא כדי להיכנס לחדר הצ'ט</div>`;
    mail.body += `<a href="${link}" target="blank">${link}</a>`;
    mail.body += `</div>`;
    this.mailService.sendMail(mail).toPromise().then(res => {

      this.loaderService.hideLoader();
      if (!res) {
        this.chatService.msgList.push({
          text: `<b style="color:red">אנחנו מצטערים, אך קרתה תקלה במערכת. אנא נסו לפנות אלינו יותר מאוחר</b>`,
          date: new Date(),
          userName: 'Bot',
          roomId: this.chatService.roomId,
          userType: this.chatService.userType
        });
      } else if (!this.route.snapshot.params.id || window.location.href.indexOf('chat-admin') < 0) {
        this.generateNewStartMsg();
      }
    }).catch(err => {
      this.gaAnalyticsService.logEventToGa('sendChatMailToAdmin', 'ChatBotInnerComponent', EVENT_TYPES.Error);
      this.loaderService.hideLoader();
      this.chatService.userName = null;
      this.isThereError = true;
      this.alertTxt = this.generalErrorMsg;
    });
  }
  closeChat() {
    if (this.chatService.msgList.length > 0) {
      const mail = new Mail();
      mail.mailType = 5;
      mail.body = `<div style="direction: rtl; text-align: right;"><h3>תיעוד הצ'ט שלך עם משתמש</h3>`;
      this.chatService.msgList.forEach((item, i) => {
        const date = new Date(item.date);
        const dateStr = date.getDate() + '-' + date.getMonth() +
          '-' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
        mail.body += `<div><b> ${item.userName}: </b>${item.text}</div><div>${dateStr}</div>`;
      });
      mail.body += `</div>`;
      this.loaderService.displayLoader(false);
      const errorMsg = `התרחשה תקלה בשליחת סיכום הצ'אט למייל`;
      this.mailService.sendMail(mail).toPromise().then(res => {
        this.loaderService.hideLoader();
        if (!res) {
          alert(errorMsg);
        } else {
          this.socket.emit('closeRoom', {});
          alert(`מייל עם סיכום הצ'אט נשלח בהצלחה`);
        }
      }).catch(err => {
        this.gaAnalyticsService.logEventToGa('closeChat', 'ChatBotInnerComponent', EVENT_TYPES.Error);
        this.loaderService.hideLoader();
        console.error(err);
        alert(errorMsg);
      });
    }
  }
  closeConnection() {
    document.querySelector('.anim-to-disable')?.classList.remove('disable-anim');
    this.appsetting.displayChatBot = false;
    this.chatService.msgList = [];
    this.socket.disconnect(true);
    this.chatService.roomId = '';
    this.chatService.userName = null;
    this.chatService.adminIsOnLive = false;
    this.chatService.inConversition = false;
  }
}


